import { render } from "./About.vue?vue&type=template&id=4904cde6&scoped=true&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=4904cde6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4904cde6"]])

export default __exports__